import * as React from 'react';
import { CTooltip, CTooltipLabel, CTooltipText } from '/client/src/components/tooltip/';
import DropZone from '/client/src/components/dropZone';
import _ from 'lodash';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

const Panel = (props) => {
  const {
    id,
    checkboxStatus,
    name,
    handleChangeCheckboxes,
    handleSetImages,
    title,
    imgUrl
  } = props;
  const context = React.useContext(DefaultContainerContext);
  const [img, setImg] = React.useState(null);

  const handleDrop = async (acceptedFiles: Array<File>, fileRejections: any) => {
    if (_.size(fileRejections)) {
      context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: fileRejections[0].errors[0].code === 'file-too-large' ? 'File is too large.' : 'Image upload failed'
      });
      return;
    }

    setImg(acceptedFiles);
  };

  React.useEffect(() => {
    handleSetImages(id, img);
  }, [img]);

  return (
    <div className="panel panel-default panel-page no-border">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8 col-lg-6">
            <div className="panel-heading1">
              <div className="form-group">
                <div
                  className="form-switcher form-switcher-lg"
                  onClick={() =>
                    handleChangeCheckboxes({
                      name,
                      checked: !checkboxStatus
                    })
                  }
                >
                  <input
                    type="checkbox"
                    checked={checkboxStatus}
                    name={name}
                    readOnly="readOnly"
                  />
                  <label className="switcher" />
                </div>
                <div>
                  {id === 'coverImg' ? (
                    <>
                      Do you want to add a cover image?
                    </>
                  ) : (
                    <>
                      Do you want to add a cover logo?
                    </>
                  )}
                </div>
              </div>
            </div>

            {checkboxStatus ? (
              <div className="form-group panel-body">
                <label>
                  {title}
                  <CTooltip>
                    <CTooltipLabel standart>?</CTooltipLabel>
                    <CTooltipText>Image dimension 2560 x 964</CTooltipText>
                  </CTooltip>
                </label>
                <div className="dropzone dropzone-single self-checkin-image">
                  <DropZone
                    imageSource={imgUrl}
                    onDrop={handleDrop}
                    noImgParams
                    onlyImages
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Panel;
